import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "./style.css";

const Contact = () => {
  useEffect(() => {
    if (window.hbspt) {
      window.hbspt.forms.create({
        portalId: "50197322",
        formId: "77f5ce38-1932-47fe-8207-568968e6921a",
        region: "na1",
        target: '#hubspotContactForm'
      });
    }
  }, []);

  return (
    <>
      <section id="contact-section" className="contact-form section_100">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="section-title  ">
                <h2>
                  Formulario de <span>contacto</span>
                </h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={8}>
              <div className="contact-form-wrapper ">
                <div id="hubspotContactForm"></div>
              </div>
            </Col>
            <div className="col-lg-4 d-flex">
              <div className="address-area ">
                <h4 className="title">Información de contacto</h4>
                <ul className="address-list">
                  <li>
                    <p>
                      <FaMapMarkerAlt /> Cerro el plomo 5931, Santiago, Chile
                    </p>
                  </li>
                  <li>
                    <p>
                      <FaEnvelope /> contacto@bestore.ai
                    </p>
                  </li>
                  <li>
                    <p>
                      <FaGlobe />
                      www.bestore.ai
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
